import React, { useEffect, useState } from 'react';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { CSVLink } from 'react-csv';
import FunctionsData from '../../Functions/FunctionsData';

export default function LinkedClinics({ vet_id }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    setLoading(true);
    FunctionsData.fetchDataGet(
      FunctionsData.getApiUrl('/api/vet/' + vet_id + '/associated/summary'),
      setData,
      true,
      setLoading
    );
  }, [vet_id]);

  const csvData = data.map((r) => ({
    supplier_name: r.supplier_name,
    issued: r.issued,
    community: (r.optout_community === 0) ? 'Opted-in' : (r.optout_community === 1 ? 'Opted-out' : '-'),
    snip_n_chip: (r.optout_public === 0) ? 'Opted-in' : (r.optout_public === 1 ? 'Opted-out' : '-'),
    redeemed: r.redeemed,
  }));

  if (loading) return <div style={{padding:20}}>Loading...</div>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Linked Clinics</h2>

      {data && data.length > 0 && (
        <div style={{ marginBottom: 12 }}>
          <CSVLink data={csvData} filename={`linked_clinics_${vet_id}.csv`}>
            <Button variant="contained">Download CSV</Button>
          </CSVLink>
        </div>
      )}

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Supplier name</TableCell>
              <TableCell>Community</TableCell>
              <TableCell>Snip'n'chip</TableCell>
              <TableCell align="right">Issued</TableCell>
              <TableCell align="right">Redeemed</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data && data.length > 0 ? (
              data.map((row, idx) => (
                <TableRow key={row.supplier_name || idx}>
                  <TableCell>{row.supplier_name}</TableCell>
                  <TableCell>{(row.optout_community === 0) ? 'Opted-in' : (row.optout_community === 1 ? 'Opted-out' : '-')}</TableCell>
                  <TableCell>{(row.optout_public === 0) ? 'Opted-in' : (row.optout_public === 1 ? 'Opted-out' : '-')}</TableCell>
                  <TableCell align="right">{row.issued ?? 0}</TableCell>
                  <TableCell align="right">{row.redeemed ?? 0}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">No linked clinics found.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
